/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { TagEntity } from '@axiom/domain';
/**
 * Response projection of the Tag entity. Extends TagEntity
 * (inherits `static key = 'Tag'`), so this projection and the full
 * Tag entity merge into the same normalized cache record.
 * dark-roast DTO: GetTagsResponseDto
 * also used by readTagsService, readTagsName, readTagsSystemEvents
 */
export class ReadTagsResponseEntity extends TagEntity {
}